import React from 'react';
import { Button, Dropdown, MenuItem } from 'react-bootstrap';
import moment from 'moment';
import { ORDER_ONGOING, ORDER_ALL, ORDER_CLOSED, DAY_KANA, DATE_FORMAT } from '../../../utils/constants';

const BPOrderButtons = (props) => {
    
    const formatDate = (date) => {
        if (!moment.isMoment(date)) {
            date = moment(new Date(date))
        }
        let day = DAY_KANA[date.format('d')];
        return date.format(DATE_FORMAT + "(" + day + ")");
    }

    return (
        <span className="title-action">
            <span className="action-order">
                <span className="extra-text0">
                    <span className="extra 処理状況">処理状況</span>
                    <Dropdown id="num-dropdown">
                        <Button className="fix-right button-num">{props.processing}</Button>
                        <Dropdown.Toggle className="button-toggle" />
                        <Dropdown.Menu className="num-dropdown">
                            <MenuItem onClick={() => props.filterProcessing(ORDER_ALL)}>{ORDER_ALL}</MenuItem>
                            <MenuItem onClick={() => props.filterProcessing(ORDER_ONGOING)}>{ORDER_ONGOING}</MenuItem>
                            <MenuItem onClick={() => props.filterProcessing(ORDER_CLOSED)}>{ORDER_CLOSED}</MenuItem>
                        </Dropdown.Menu>
                    </Dropdown>
                </span>
            </span>

            <span className="action-order">
                <Button
                    className="extra-button"
                    onClick={() => props.setModal()}
                >
                    発注締日
                </Button>
                <span className="extra-text">{formatDate(props.filterStartDate)}～{formatDate(props.filterEndDate)}</span>
            </span>

            <span className="action-order">
                <Button
                    className="extra-button"
                    onClick={() => props.setProposal()}
                >
                    商品提案G
            </Button>
                <span className="extra-text">{props.proposalName}</span>
            </span>
        </span>
    );
}

export default BPOrderButtons;